import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pageTitle  , isHome } from './../../actions'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import {pagesize} from './../../actions'

class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            style:"normal",
            checked:false
        }
    }
    componentDidMount() {
        this.props.dispatch(isHome(false))
        this.props.dispatch(pageTitle("تنظیمات"));
        const selected_size = localStorage.getItem("fontSize");
        this.setState({style:selected_size});
        this.getNotificationPermissionState();
    }
    handleChange = e=>{
        this.setState({[e.target.name]:e.target.value},()=>{
            
        });
        this.props.dispatch(pagesize(e.target.value));
        localStorage.setItem("fontSize", e.target.value);

    }
    askPermission = async () => {
        let currentPermissionState = await this.getNotificationPermissionState()
        if(! ('serviceWorker' in navigator) && ! ('PushManager' in window) ) {
            return;
        }

        if(currentPermissionState !== 'granted') {
          let result = await Notification.requestPermission()
          if(result !== 'granted') {
              this.setState({checked:false})
              return;
          } else {
            this.setState({checked:true})
              new Notification('با تشکر' , {});
              // navigator.serviceWorker.ready
              //   .then(registration => {
              //     registration.showNotification('با تشکر' , {})
              //   })
          }
        }else{

        }
      }
      handleCheckChange = ()=>{
          this.setState({checked:!this.state.checked},()=>{
              if(this.state.checked){
                  this.askPermission();
              }
          });
      }
      getNotificationPermissionState = async () => {
        if(navigator.permissions) {
            let result = await navigator.permissions.query({ name : 'notifications'})
            if(result.state === "granted"){
                this.setState({checked:true})
            }
            return result.state;
        }
    }
    render() {
        const {  style } = this.state;
        return (
            <div className="setting-panel">
                <div className="style-size">
                    <h3 className="setting-title">اندازه فونت نرم افزار را انتخاب نمایید</h3>
                    <FormControl component="fieldset" >
                        <RadioGroup aria-label="font" name="style" value={style} onChange={this.handleChange}>
                            <FormControlLabel
                                value="normal"
                                control={<Radio color="primary" />}
                                label="حالت استاندارد"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="big"
                                control={<Radio color="primary" />}
                                label="بزرگ"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="small"
                                control={<Radio color="primary" />}
                                label="کوچک"
                                labelPlacement="start"
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
                {/* <span className="" onClick={this.askPermission}>
                    فعال بودن اعلانها: 
                </span> */}
                {/* <Switch
                checked={checked}
                onChange={this.handleCheckChange}
                value="checkedB"
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
            /> */}
            </div>
        );
    }
}
export default connect()(Setting);